import React, { useEffect, useState } from "react"
import InfoIcon from "@mui/icons-material/Info"
import CloseIcon from "@mui/icons-material/Close"
import { Backdrop, Button, CircularProgress, Typography } from "@mui/material"

import useStyles from "./useStyles"
import Table from "./TableNavigable/TableNavigable.js"
import { useDispatch, useSelector } from "react-redux"
import {
  deleteSearchClientNameValue,
  deleteSearchStatusValue,
  deleteSearchValue,
  getAllSubscriptionsCommunication,
  suscribersStatusVERequest,
} from "../../../redux/actions/eventanilla.js"
import FilterButton from "../../../components/FilterButton/FilterButton.jsx"
import FilterInput from "../../../components/FilterInput/FilterInput.jsx"
import FilterInputStatus from "../../../components/FilterInputStatus/FilterInput.jsx"
import { statusConfig } from "./utils/statusConfig.js"
import { useNavigate } from "react-router-dom"
// import CreateClient from "../../Clients/CreateClient/CreateClient.jsx"
// import { getFirmsCustomer } from "../../../redux/actions/clients.js"

export default function Home() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [loading, setloading] = useState(false)
  const navigate = useNavigate()
  const eventanilla = useSelector((state) => state.eventanilla)
  // const [modalOpen, setModalOpen] = useState(false)
  const getSubscriptions = async () => {
    setloading(true)
    await dispatch(
      getAllSubscriptionsCommunication(
        eventanilla.searchValueCUIT || null,
        eventanilla.searchClientName || null,
        eventanilla.searchStatus || null,
      ),
    )
    setloading(false)
  }
  const getTitleStatus = (code) => {
    return statusConfig.find((status) => status.code === code).title || ""
  }

  const deleteValueSearch = async () => {
    dispatch(deleteSearchValue(eventanilla.searchValueCUIT))
    await dispatch(
      getAllSubscriptionsCommunication(
        null,
        eventanilla.searchClientName,
        eventanilla.searchStatus,
      ),
    )
  }

  const deleteValueSearchClientName = async (name) => {
    const newList = eventanilla.searchClientName.filter(
      (clientName) => clientName !== name,
    )
    dispatch(deleteSearchClientNameValue(newList.length > 0 ? newList : null))
    await dispatch(
      getAllSubscriptionsCommunication(
        eventanilla.searchValueCUIT,
        newList.length > 0 ? newList : null,
        eventanilla.searchStatus,
      ),
    )
  }

  const deleteValueSearchStatus = async () => {
    dispatch(deleteSearchStatusValue())
    await dispatch(
      getAllSubscriptionsCommunication(
        eventanilla.searchValueCUIT,
        eventanilla.searchClientName,
        null,
      ),
    )
  }

  useEffect(() => {
    if (!eventanilla.subscribers) getSubscriptions()
    return () => {
      dispatch(suscribersStatusVERequest())
    }
  }, [])

  if (loading) {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <div className={classes.boxtitle}>
        <Typography className={classes.title}>
          e-Ventanilla - Clientes Asociados
        </Typography>
      </div>
      <div className={classes.boxSubTitle}>
        <InfoIcon style={{ color: "#00a78f", marginLeft: 10 }} />
        <Typography className={classes.subtitle}>
          En esta sección puede administrar el estado de los CUIT de los
          clientes de Mi Estudio asociados a una Organización
        </Typography>
      </div>

      <div className={classes.boxTable}>
        <div className={classes.boxSearchBar}>
          <FilterButton searchType="eventanilla" />
          <FilterInput searchType="eventanilla" />
          <FilterInputStatus />
        </div>
        <div>
          <div className={classes.containerSearchValueButton}>
            {eventanilla.searchValueCUIT && (
              <button
                className={classes.buttonResetFilterCUIT}
                onClick={deleteValueSearch}
              >
                <Typography className={classes.typographyButton}>
                  {eventanilla.searchValueCUIT}
                </Typography>
                <CloseIcon className={classes.closeIconButtonReset} />
              </button>
            )}
            {eventanilla.searchClientName &&
              eventanilla.searchClientName.map((name) => (
                <button
                  className={classes.buttonResetFilterClientName}
                  onClick={() => deleteValueSearchClientName(name)}
                  key={name}
                >
                  <Typography className={classes.typographyButton}>
                    {name}
                  </Typography>
                  <CloseIcon className={classes.closeIconButtonReset} />
                </button>
              ))}
            {eventanilla.searchStatus && (
              <button
                className={classes.buttonResetFilterClientName}
                onClick={deleteValueSearchStatus}
              >
                <Typography className={classes.typographyButton}>
                  {getTitleStatus(eventanilla.searchStatus)}
                </Typography>
                <CloseIcon className={classes.closeIconButtonReset} />
              </button>
            )}
          </div>
        </div>
        {eventanilla.subscribers &&
        eventanilla.subscribers.length > 0 &&
        !eventanilla.loading ? (
          <Table rows={eventanilla.subscribers} />
        ) : eventanilla.loading ? (
          <div
            style={{
              width: "100%",
              height: "calc(100vh - 16rem)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#00a78f",
            }}
          >
            <CircularProgress color="inherit" />
          </div>
        ) : (
          <>
            <div
              style={{
                width: "100%",
                height: "calc(100vh - 16rem)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                color: "#4B4952",
                fontSize: "1rem",
                fontWeight: "bold",
                flexDirection: "column",
              }}
            >
              No se encontraron estados
              <div
                style={{
                  textAlign: "center",
                  paddingTop: "2.5rem",
                  color: "#6B6B6B",
                  fontSize: "0.9rem",
                  marginBottom: "1rem",
                }}
              >
                <Typography>
                  Consulte la información de estudios asociados a este CUIT{" "}
                  <br></br>en la sección de clientes.
                </Typography>
              </div>
              <Button
                className={classes.buttonsearch}
                onClick={() => {
                  if (eventanilla.searchValueCUIT) {
                    navigate(`/ME/clientes/${eventanilla.searchValueCUIT}`, {
                      state: { dataLoaded: false },
                    })
                  } else {
                    navigate(`/ME/clientes/`)
                  }
                }}
              >
                <Typography sx={{ fontSize: "12px", fontWeight: "bold" }}>
                  {" "}
                  Ir a Clientes
                </Typography>
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  )
}
